<template>
  <div id="contenedor-card-listado-reporte-ejecutivo">
    <template
      v-for="(reporte, index) in listado">
      <div
        v-if="index <= 1"
        class="clear"
        :key="`page-break-${reporte.id}`">
        &nbsp;
      </div>
      <template>
        <v-card
          :key="reporte.id"
          elevation="1"
          outlined
          width="100%"
          class="mb-4 page-break">
          <v-card-title
            class="primary--text">
            {{ reporte.contrato.numero }}
            <v-chip
              v-if="reporte.contrato.estatus"
              class="ml-2"
              small
              :color="reporte.contrato.estatus.color"
              :dark="reporte.contrato.estatus.esTextoClaro">
              {{ reporte.contrato.estatus.nombre }}
            </v-chip>
            <v-btn
              v-if="!imprimir"
              text
              small
              class="ml-2"
              @click="mostrarDetalles(reporte.id)">
              Detalles
            </v-btn>
            <v-spacer></v-spacer>
            <div class="caption">
              <span
                class="subtitle-2">
                Fecha del reporte:
              </span>
              <span>
                {{ new Date(`${reporte.fecha} 00:00:0`).toLocaleDateString() }}
              </span>
            </div>
          </v-card-title>
          <v-card-subtitle
            class="caption">
            {{ reporte.contrato.meta }}
          </v-card-subtitle>
          <v-card-text>
            <v-row
              no-gutters
              class="mb-5"
              v-show="listadoMostrarDetalles.includes(reporte.id) || imprimir">
              <v-col
                cols="4">
                <span class="secondary--text font-weight-bold">Fecha de inicio contractual:</span>
              </v-col>
              <v-col
                cols="4"
                md="4">
                <span class="secondary--text font-weight-bold">Fecha de término contractual:</span>
              </v-col>
              <v-col
                cols="4"
                md="4">
                <span class="secondary--text font-weight-bold">Monto de contrato:</span>
              </v-col>
              <v-col
                cols="4"
                md="4">
                <span>
                  {{ new Date(`${reporte.contrato.fechaInicio} 00:00:0`).toLocaleDateString() }}
                </span>
              </v-col>
              <v-col
                cols="4"
                md="4">
                <span>
                  {{ new Date(`${reporte.contrato.fechaTermino} 00:00:0`).toLocaleDateString() }}
                </span>
              </v-col>
              <v-col
                cols="4"
                md="4">
                {{ reporte.contrato.importe | currency }}
              </v-col>
              <v-col
                cols="4"
                md="4">
                <span class="secondary--text font-weight-bold">Contratista:</span>
              </v-col>
              <v-col
                cols="4"
                md="4">
                <span class="secondary--text font-weight-bold">Supervisor:</span>
              </v-col>
              <v-col
                cols="4"
                md="4">
                <span class="secondary--text font-weight-bold">Monto de anticipo:</span>
              </v-col>
              <v-col
                cols="4"
                md="4">
                {{ reporte.contrato.contratista.nombreRazonSocial }}
              </v-col>
              <v-col
                cols="4"
                md="4">
                <span
                  v-if="reporte.contrato.responsables.length > 0">
                  {{ reporte.contrato.responsables[0].funcionario.nombre }}
                </span>
              </v-col>
              <v-col
                cols="4"
                md="4">
                {{ reporte.importeTotalAnticipo | currency }}
              </v-col>
              <v-col
                cols="4"
                md="4">
                <span class="secondary--text font-weight-bold">Supervisión Externa:</span>
              </v-col>
              <v-col
                cols="4"
                md="4">
                <span class="secondary--text font-weight-bold">Programa:</span>
              </v-col>
              <v-col
                cols="4"
                md="4">
                <span class="secondary--text font-weight-bold">Fecha de anticipo:</span>
              </v-col>
              <v-col
                cols="4"
                md="4">
              </v-col>
              <v-col
                cols="4"
                md="4">
              </v-col>
              <v-col
                cols="4"
                md="4">
                <span
                  v-if="reporte.contrato.anticipos.length > 0">
                  {{ new Date(`${reporte.contrato.anticipos[0].fecha} 00:00:0`)
                    .toLocaleDateString() }}
                </span>
              </v-col>
            </v-row>
            <v-divider
              class="my-3">
            </v-divider>
            <!-- Comentarios del supervisor -->
            <v-row>
              <v-col
                cols="4">
                <h3 class="subtitle-2 secondary--text text-uppercase">
                  comentarios de avance
                </h3>
                <p>
                  {{ reporte.comentarios }}
                </p>
              </v-col>
              <v-col
                cols="4">
                <h3
                  class="subtitle-2 red--text text--darken-1 text-uppercase"
                  :class="{'text--disabled': !reporte.existeProblema }">
                  problemática
                </h3>
                <p>
                  {{ reporte.descripcionProblema }}
                </p>
              </v-col>
              <v-col
                cols="4">
                <h3 class="subtitle-2 secondary--text text-uppercase">
                  comentarios de la dirección
                </h3>
                <p>
                  <span
                    class="mb-3 d-block">
                    {{ reporte.comentariosDireccion }}
                  </span>
                  <custom-button
                    v-if="!imprimir"
                    class="d-print-none"
                    tipo="agregar"
                    @click="comentarios(reporte)"
                    block
                    label="Actualizar comentarios"
                    iconText="mdi-comment">
                  </custom-button>
                </p>
              </v-col>
            </v-row>
            <div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-chip
              class="mr-2"
              color="naranja2"
              small>
              Programado
              <span
                class="font-weight-bold ml-1">
                {{ reporte.avanceProgramado }}%
              </span>
            </v-chip>
            <v-chip
              class="mr-2"
              color="azul1"
              small>
              Físico
              <span
                class="font-weight-bold ml-1">
                {{ reporte.avanceFisico }}%
              </span>
            </v-chip>
            <v-chip
              class="mr-2"
              color="verde1"
              small>
              Financiero
              <span
                class="font-weight-bold ml-1">
                {{ reporte.avanceFinanciero }}%
              </span>
            </v-chip>
            <v-chip
              class="mr-2"
              :color="reporte.descripcionAtraso.color"
              :dark="reporte.descripcionAtraso.dark"
              small>
              {{ reporte.descripcionAtraso.texto }}
              <template
                v-if="reporte.porcentajeDeAtraso <= 0">
                <span
                  class="font-weight-bold ml-1">
                  {{ (reporte.porcentajeDeAtraso * -1) }}%
                </span>
              </template>
              <template
                v-else>
                <span
                  class="font-weight-bold ml-1">
                  {{ reporte.porcentajeDeAtraso }}%
                </span>
              </template>
            </v-chip>
          </v-card-actions>
          <!-- Album fotografico -->
          <v-card-text
            v-if="reporte.albumFotografico.length > 0">
            <v-subheader>Álbum fotográfico</v-subheader>
            <v-row>
              <template
                v-for="(imagen, index) in reporte.albumFotografico">
                <template>
                  <v-col
                    :key="imagen.id"
                    cols="auto"
                    class="contenedor-imagenes mr-2 mb-2 image-clic">
                    <v-img
                      v-if="!imprimir"
                      :src="`${$urlFileServer}/${imagen}/thumbnail`"
                      width="180"
                      height="180"
                      @click="mostrarImagenes(reporte, index)">
                      <template
                        v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center">
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-1">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <img
                      v-else
                      :src="`${$urlFileServer}/${imagen}/thumbnail`"
                      width="180"
                      height="180"
                      alt="img">
                  </v-col>
                </template>
              </template>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
      <!-- <div class="page-break" :key="`page-break-${reporte.id}`">&nbsp;</div> -->
    </template>
    <v-dialog
      v-model="mostrarActualizarComentariosDireccion"
      width="600"
      persistent>
      <actualizar-comentarios-direccion
        v-if="esteReporte"
        :reporte="esteReporte"
        v-on:cerrar="cerrar">
      </actualizar-comentarios-direccion>
    </v-dialog>
    <v-dialog
      v-model="mostrarCarouselImagenes"
      width="700"
      dark
      scrollable>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="mostrarCarouselImagenes = !mostrarCarouselImagenes">
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <imagen-carousels
            :current-index="imagenIndexSeleccionada"
            :imagenes="imagenes"
            v-on:cambioDeImagen="cambioDeImagen">
          </imagen-carousels>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="mixDescargarImagen"
            :disabled="descargandoImagen"
            :loading="descargandoImagen">
            <v-icon>
              file_download
            </v-icon>
            Descargar imagen
          </v-btn>
          <!-- <v-btn>
            <v-icon>
              file_download
            </v-icon>
            Descargar todas
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import fileDownload from 'js-file-download';
import ActualizarComentariosDireccion from '@/components/administracion/ejecucion/reportes/ActualizarComentariosDireccion.vue';
import ImagenCarousels from '@/components/ImagenCarousels.vue';
import CustomButton from '@/components/buttons/Button.vue';

let baseURL = 'https://sideop-file-server.daesaingenieria.com';
if (process.env.NODE_ENV !== 'production') {
  baseURL = 'http://localhost:3001';
}

export default {
  name: 'CardListadoReporteEjecutivo',
  components: {
    ActualizarComentariosDireccion,
    CustomButton,
    ImagenCarousels,
  },
  props: {
    listado: {
      type: Array,
      required: true,
    },
    imprimir: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      mostrarActualizarComentariosDireccion: false,
      mostrarCarouselImagenes: false,
      imagenIndexSeleccionada: 0,
      listadoMostrarDetalles: [],
      imagenes: [],
      esteReporte: null,
      imagenSeleccionada: null,
      progresoDescarga: 0,
      descargandoImagen: false,
    };
  },
  methods: {
    cambioDeImagen(imagen) {
      this.imagenSeleccionada = imagen;
    },
    comentarios(reporte) {
      this.esteReporte = reporte;
      this.mostrarActualizarComentariosDireccion = true;
    },
    mostrarDetalles(id) {
      if (this.listadoMostrarDetalles.includes(id)) {
        const index = this.listadoMostrarDetalles.indexOf(id);
        this.listadoMostrarDetalles.splice(index, 1);
        return;
      }
      this.listadoMostrarDetalles.push(id);
    },
    mostrarImagenes(reporte, index) {
      this.esteReporte = reporte;
      this.imagenIndexSeleccionada = index;
      this.imagenes = reporte.albumFotografico.map((key) => `${baseURL}/${key}`);
      this.imagenSeleccionada = this.imagenes[index];
      this.mostrarCarouselImagenes = true;
    },
    cerrar() {
      this.esteReporte = null;
      this.mostrarActualizarComentariosDireccion = false;
    },
    async mixDescargarImagen() {
      this.descargandoImagen = true;
      await this.axios.get(
        this.imagenSeleccionada,
        {
          responseType: 'blob',
          onDownloadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              this.progresoDescarga = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
            }
          },
        },
      )
        .then((res) => {
          fileDownload(res.data,
            `${this.esteReporte.contrato.numero}_${this.imagenIndexSeleccionada}.jpg`);
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        })
        .finally(() => {
          this.descargandoImagen = false;
        });

      this.progresoDescarga = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-break {
  break-after: always !important;
  break-before: always !important;
  page-break-before: always !important;
}
.clear { clear: both; }
.image-clic {
  cursor: pointer;
}
</style>
